import React from "react"
import { Link } from "gatsby"
import { connectHits } from "react-instantsearch-dom"

export const WizardHits = connectHits(({ hits }) => {
  return (
    <React.Fragment>
      <p className="title is-4 has-text-mitternachtsblau has-text-centered">
        Passende Aufträge für Sie
      </p>
      <div className="columns is-multiline">
        {hits.map(({ ServiceTypeName, TitelOnline, RefIDStringBI }) => {
          return (
            <div className="column is-half is-flex" key={RefIDStringBI}>
              <Link
                to={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}`}
                className="box is-flex-grow-1"
              >
                <p className="has-text-evergabe has-text-weight-bold">
                  {ServiceTypeName}
                </p>
                <p className="title is-6 has-text-mitternachtsblau">
                  {TitelOnline}
                </p>
              </Link>
            </div>
          )
        })}
      </div>
    </React.Fragment>
  )
})
